import axios from 'axios';
import { PHASES_API_URL } from '../../constants/urls';

const state = {
    currentPhase: null,
    currentPhaseTitle: null,
    votingStages: null,
    votingStagesDescriptions: null,
    votingStagesText: null,
    isAwardsTime: null,
    awardsLink: null,
};

const actions = {
    getPhases({ commit }) {
        const host = this.state.context.host;

        const url = host + PHASES_API_URL;

        axios.get(url,{ withCredentials: true })
            .then((result) => {
                commit('currentPhase', result.data.currentStage);
                commit('currentPhaseTitle', result.data.currentStageDescription);
                commit('votingStages', result.data.votingStages);
                commit('votingStagesDescriptions', result.data.votingStagesDescriptions);
                commit('votingStagesText', result.data.votingStagesText);

                if (result.data.awardsTranslation) {
                    commit('isAwardsTime', true);
                    commit('awardsLink', result.data.awardsTranslation);
                } else {
                    commit('isAwardsTime', false);
                }
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },
};

const mutations = {
    currentPhase(state, value) {
        state.currentPhase = value;
    },

    currentPhaseTitle(state, value) {
        state.currentPhaseTitle = value;
    },

    votingStages(state, value) {
        state.votingStages = value;
    },

    votingStagesDescriptions(state, value) {
        state.votingStagesDescriptions = value;
    },

    votingStagesText(state, value) {
      state.votingStagesText = value;
    },

    isAwardsTime(state, value) {
        state.isAwardsTime = value;
    },

    awardsLink(state, value) {
        state.awardsLink = value;
    },
};

const getters = {
    currentPhase({ currentPhase }) {
        return currentPhase;
    },

    currentPhaseTitle({ currentPhaseTitle }) {
        return currentPhaseTitle;
    },

    votingStages({ votingStages }) {
        return votingStages;
    },

    votingStagesDescriptions({ votingStagesDescriptions }) {
        return votingStagesDescriptions;
    },

    votingStagesText({ votingStagesText }) {
      return votingStagesText;
    },

    isAwardsTime({ isAwardsTime }) {
        return isAwardsTime;
    },

    awardsLink({ awardsLink }) {
        return awardsLink;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/phases.js